import { jsx as _jsx } from "react/jsx-runtime";
import { InputWrapper } from "./InputWrapper";
export function CustomInput(props) {
    // the InputWrapper renders it's children plus a label, helpBlock and any error message from the field validation
    return (_jsx(InputWrapper, Object.assign({}, props, { children: _jsx(InputElement, Object.assign({}, props)) })));
}
const InputElement = (props) => {
    let className = "is-valid";
    if (props.meta.touched || props.meta.submitFailed) {
        if (props.meta.invalid) {
            className = "is-invalid";
        }
    }
    if (props.disabled) {
        className = "disabled";
    }
    return (_jsx("input", Object.assign({}, props.input, { id: props.input.name, type: props.input.type, className: `${className}`, placeholder: props.placeholder, "aria-required": props.required, autoFocus: props.autoFocus, autoComplete: props.autoComplete, onFocus: props.onFocus, readOnly: props.readOnly, "aria-invalid": props["aria-invalid"], "aria-errormessage": props["aria-errormessage"] })));
};
